import React, { useMemo } from 'react';
import DigitsContainer, { DigitsContainerInputType } from '../../../generic-components/DigitsContainer';
import { ChangePhoneFlow } from '../ChangePhoneSteps';
import { ErrorData } from '../ChangePhone';
import { LiliInternationalPhoneNumberInput } from '../../../DesignSystem/LiliInternationalPhoneNumberInput/LiliInternationalPhoneNumberInput';
import { WizardFlowActionType } from '../logic/WizardContext';

type HandleOnInputChange = (value: string) => void;
type NationalIdDescription = boolean;
type InputData = string;

export interface StepViewComponentsProps {
  numOfDigits: number;
  handleOnInputChange: HandleOnInputChange;
  nationalIdDescription: NationalIdDescription;
  error?: ErrorData;
  inputData: InputData;
  step: ChangePhoneFlow;
  dispatch: React.Dispatch<any>;
  type?: DigitsContainerInputType;
}

const style = {
  DIGITS_CONTAINER_SSN_WRAPPER: 'h-[58px] flex  mb-[26px] flex flex-col',
  DIGITS_CONTAINER: 'flex justify-between gap-2.5',
};

export const MemoizedDigitsContainer = ({
  numOfDigits,
  handleOnInputChange,
  nationalIdDescription,
  error,
  dispatch,
  type = DigitsContainerInputType.NUMBER_AND_LETTERS,
}: StepViewComponentsProps) =>
  useMemo(
    () => (
      <div className={style.DIGITS_CONTAINER_SSN_WRAPPER}>
        <DigitsContainer
          needCleanParentState
          resetIsError={() => {
            dispatch({ type: 'set_data', payload: { error: undefined } });
          }}
          containerClassName='flex justify-between gap-4'
          isError={Boolean(error)}
          isLoading={false}
          numOfDigits={numOfDigits}
          onFulfill={handleOnInputChange}
          inputType={type}
        />
        <p className={`font-metricRMedium text-[14px] text-red02  ${error?.errorMessage ? 'visible' : 'invisible'}`}>
          {error?.errorMessage}
        </p>
      </div>
    ),
    [numOfDigits, handleOnInputChange, nationalIdDescription, error],
  );

interface PhoneInputComponentProps {
  handleOnInputChange: HandleOnInputChange;
  nationalIdDescription: NationalIdDescription;
  error?: ErrorData;
  inputData: InputData;
  fieldValidationStatus: (value: boolean) => void;
}
export const PhoneInputComponent = ({
  handleOnInputChange,
  error,
  inputData,
  nationalIdDescription,
  fieldValidationStatus,
}: PhoneInputComponentProps) => (
  <LiliInternationalPhoneNumberInput
    id='change-phone-step-input'
    inputValue={inputData}
    onInputValueChange={handleOnInputChange}
    errorMessage={error?.errorMessage}
    isDisabled={!nationalIdDescription}
    fieldValidationStatus={fieldValidationStatus}
  />
);

export const renderMap = (props: StepViewComponentsProps) => {
  const fieldValidationStatus = (isPhoneValid: boolean) => {
    props.dispatch({
      type: WizardFlowActionType.SET_IS_PHONE_VALID,
      payload: isPhoneValid,
    });
  };
  const { step } = props;
  const creditCardProps = { ...props, type: DigitsContainerInputType.NUMBERS };
  return {
    [ChangePhoneFlow.SSN]: <MemoizedDigitsContainer {...props} />,
    [ChangePhoneFlow.CREDIT_CARD]: <MemoizedDigitsContainer {...creditCardProps} />,
    [ChangePhoneFlow.MAIL_VERIFICATION]: <MemoizedDigitsContainer {...props} />,
    [ChangePhoneFlow.PHONE_INPUT]: <PhoneInputComponent {...props} fieldValidationStatus={fieldValidationStatus} />,
    [ChangePhoneFlow.ERROR]: <div />,
    [ChangePhoneFlow.NONE]: <div />,
  }[step];
};
